import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { environment } from '../../environments/environment';

@Injectable()
export class AuthService {

    authUrl = environment.authUrl;

    constructor(private router: Router,
        private http: Http) { }

    signin(password: string, email: string): Observable<any> {
        return this.http.post(this.authUrl + '/signin', { password: password, email: email })
            .map(this.extractData)
            .catch(this.handleError);
    }

    login(email: string, password: string): Observable<any> {
        return this.http.put(this.authUrl + '/login', { email: email, password: password })
            .map(this.extractData)
            .catch(this.handleError);
    }

    logout() {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('account');
        this.router.navigate(['/login']);
    }

    checkToken(): Observable<any> {
        var token = 'Bearer ' + this.getUserToken();
        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);

        return this.http.get(this.authUrl + '/token', { headers: headers })
            .map(this.extractData)
            .catch(this.handleError);
    }

    getUserToken() {
        var userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        return userInfo.token || '';
    }

    saveUserToken(token: string) {
        localStorage.setItem('userInfo', JSON.stringify({ token: token }));
    }

    saveAccount(account: any) {
        localStorage.setItem('account', JSON.stringify(account || {}));
    }

    changeMail(email: string) {
        var token = 'Bearer ' + this.getUserToken();
        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);

        return this.http.put(this.authUrl + '/change-mail', { email: email }, { headers: headers })
            .map(this.extractData)
            .catch(this.handleError);
    }

    forgotPassword(email: string) {
        return this.http.put(this.authUrl + '/forgot-password', { email: email })
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body;
    }

    private handleError(error: Response | any) {
        let errMsg: any;
        if (error instanceof Response) {
            errMsg = error.json();
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
}
